import React, { useState, useEffect } from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from 'recharts'
import { ChapterStats } from '../types/stats'

interface ChaptersChartProps {
  data: ChapterStats[]
}

const ChaptersChart: React.FC<ChaptersChartProps> = ({ data }) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768)
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  const chartHeight = Math.max(300, data.length * 50)

  const truncateName = (name: string, maxLength: number) => {
    if (name.length <= maxLength) return name
    return name.substring(0, maxLength - 1) + '…'
  }

  const displayData = isMobile
    ? data.map(item => ({ ...item, chapterName: truncateName(item.chapterName, 16) }))
    : data

  return (
    <div className="bg-white rounded-lg shadow-[0px_5px_12px_rgba(0,0,0,0.1)] p-4 md:p-6">
      <h2 className="font-ibm-plex-sans font-bold text-xl text-black mb-6">
        Rozdziały
      </h2>

      <div style={{ height: chartHeight }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={displayData}
            layout="vertical"
            margin={{ top: 5, right: 0, left: 0, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e5e5" horizontal={false} />
            <XAxis
              type="number"
              tick={{ fontSize: 12 }}
              allowDecimals={false}
            />
            <YAxis
              type="category"
              dataKey="chapterName"
              tick={{ fontSize: isMobile ? 11 : 12 }}
              width={isMobile ? 120 : 200}
              tickMargin={5}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'white',
                border: '1px solid #e5e5e5',
                borderRadius: '8px'
              }}
              formatter={(value) => [value, 'Odtworzenia']}
            />
            <Bar dataKey="totalPlays" radius={[0, 4, 4, 0]}>
              {displayData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={entry.totalPlays === 0 ? '#e5e5e5' : '#000000'}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default ChaptersChart
